<template>
  <div
    :id="module.id"
    class="cover"
    :style="{ backgroundColor: module.config.general.backgroundColor.value }"
  >
    <component :is="module.config.general.template.component">
      <template #media>
        <CoverUIMedia :general="module.config.general" :lazy="lazy" />
      </template>

      <template v-if="showHeader(module)" #header>
        <CoverUIHeader
          :header="module.config.header"
          :general="module.config.general"
        />
      </template>

      <template #jobCounter>
        <CoverUIJobCounter
          :general="module.config.general"
          :job-counter="module.config.jobCounter"
          :job-count-string="jobCountString"
        />
      </template>

      <template v-if="module.config.general.ctaType.value === 'Search'" #search>
        <GlobalUISearch :search="module.config.search" />
      </template>

      <template
        v-else-if="module.config.general.ctaType.value === 'Button'"
        #ctaButton
      >
        <GlobalUICtaButton
          :cta-button="module.config.ctaButton"
          @click="$emit('emittedClick', module.config)"
        />
      </template>
    </component>
  </div>
</template>

<script>
import coverModule from "./coverDefaultModuleProp";
import GlobalUICtaButton from "../GlobalUI/GlobalUICtaButton.vue";
import GlobalUISearch from "../GlobalUI/GlobalUISearch.vue";
import CoverUIHeader from "./UI/CoverUIHeader.vue";
import CoverUIJobCounter from "./UI/CoverUIJobCounter.vue";
import CoverUIMedia from "./UI/CoverUIMedia.vue";

import CoverCenter from "./Templates/CoverCenter.vue";
import CoverLeftSided from "./Templates/CoverLeftSided.vue";
import CoverRightDetached from "./Templates/CoverRightDetached.vue";
import CoverLeftSplit from "./Templates/CoverLeftSplit.vue";
import CoverBottom from "./Templates/CoverBottom.vue";
import CoverCorner from "./Templates/CoverCorner.vue";
import CoverRightSplit from "./Templates/CoverRightSplit.vue";
import CoverLeftDetached from "./Templates/CoverLeftDetached.vue";
import { globalMethods } from "../GlobalUI/mixins/global.js";

export default {
  name: "Cover",
  components: {
    GlobalUICtaButton,
    GlobalUISearch,
    CoverUIMedia,
    CoverUIHeader,
    CoverUIJobCounter,

    CoverCenter,
    CoverLeftSided,
    CoverRightDetached,
    CoverLeftSplit,
    CoverBottom,
    CoverCorner,
    CoverRightSplit,
    CoverLeftDetached,
  },
  mixins: [globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return coverModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
    jobCountString: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.cover {
  container-type: inline-size;
  contain: layout;
  min-height: 100vh;
}
</style>
